import Vue from 'vue'

//  This is a custom vue directive which doesn't work very nice with TS

Vue.directive('click-outside-color', {
  inserted: function (el, binding, vnode) {
    //@ts-ignore
    el.eventSetDrag = function () {
        el.setAttribute('data-dragging', 'yes');
    }
    //@ts-ignore
    el.eventClearDrag = function () {
        el.removeAttribute('data-dragging');
    }
    //@ts-ignore
    el.eventOnClick = function (event) {
        var dragging = el.getAttribute('data-dragging');
        // Check that the click was outside the el and its children, and wasn't a drag
        if (!(el == event.target || el.contains(event.target)) && !dragging) {
            // call method provided in attribute value
            vnode.context[binding.expression](event, binding.arg);
        }
    };
    //@ts-ignore
    document.addEventListener('touchstart', el.eventClearDrag);
    //@ts-ignore
    document.addEventListener('touchmove', el.eventSetDrag);
    //@ts-ignore
    document.addEventListener('click', el.eventOnClick);
    //@ts-ignore
    document.addEventListener('touchend', el.eventOnClick);
}, unbind: function (el) {
    //@ts-ignore
    document.removeEventListener('touchstart', el.eventClearDrag);
    //@ts-ignore
    document.removeEventListener('touchmove', el.eventSetDrag);
    //@ts-ignore
    document.removeEventListener('click', el.eventOnClick);
    //@ts-ignore
    document.removeEventListener('touchend', el.eventOnClick);
    el.removeAttribute('data-dragging');
}});
